/*
  LCC 4a — Buscador de vehículo (v1 sobre colecciones existentes)
  Lee el JSON embebido por la sección "Encuentra la pieza exacta" y arma
  el selector Marca > Línea. Al confirmar, navega a la colección real
  asociada y guarda la elección en LCCGarage (ver lcc-4a-garage.js).
*/
(function () {
  'use strict';

  function init() {
    var dataEl = document.getElementById('lcc-finder-data');
    var brandSelect = document.getElementById('lcc-finder-brand');
    var lineSelect = document.getElementById('lcc-finder-line');
    var goButton = document.getElementById('lcc-finder-go');
    if (!dataEl || !brandSelect || !lineSelect || !goButton) return;

    var lines;
    try {
      lines = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!lines || !lines.length) return;

    var brands = [];
    lines.forEach(function (line) {
      if (brands.indexOf(line.brand) === -1) brands.push(line.brand);
    });

    brands.forEach(function (brand) {
      var opt = document.createElement('option');
      opt.value = brand;
      opt.textContent = brand;
      brandSelect.appendChild(opt);
    });

    function populateLines(brand) {
      lineSelect.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = lineSelect.getAttribute('data-placeholder') || 'Línea';
      lineSelect.appendChild(placeholder);

      var matches = lines.filter(function (line) { return line.brand === brand; });
      matches.forEach(function (line) {
        var opt = document.createElement('option');
        opt.value = line.url;
        opt.textContent = line.name;
        opt.setAttribute('data-brand', line.brand);
        opt.setAttribute('data-name', line.name);
        lineSelect.appendChild(opt);
      });

      lineSelect.disabled = matches.length === 0;
      goButton.disabled = true;
    }

    brandSelect.addEventListener('change', function () {
      if (brandSelect.value) {
        populateLines(brandSelect.value);
      } else {
        lineSelect.innerHTML = '<option value="">' + (lineSelect.getAttribute('data-placeholder') || 'Línea') + '</option>';
        lineSelect.disabled = true;
        goButton.disabled = true;
      }
    });

    lineSelect.addEventListener('change', function () {
      goButton.disabled = !lineSelect.value;
    });

    goButton.addEventListener('click', function () {
      var selectedOption = lineSelect.options[lineSelect.selectedIndex];
      if (!selectedOption || !selectedOption.value) return;
      var brand = selectedOption.getAttribute('data-brand');
      var name = selectedOption.getAttribute('data-name');
      var url = selectedOption.value;

      if (window.LCCGarage) {
        window.LCCGarage.set({
          brand: brand,
          line: name,
          collectionUrl: url,
          label: brand + ' ' + name
        });
      }
      window.location.href = url;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
